import CardsFactory from './CardsFactory';
export default CardsFactory;
//# sourceMappingURL=index.js.map